import axios from 'axios';

import { SineHeader } from '../../shared/types';
import apiVersionService from './apiVersion.service';

function startsWith(haystack = '', needle = '') {
  return haystack.indexOf(needle) === 0;
}

const coreApiVersionInterceptor = axios.interceptors.response.use((response) => {
  if (startsWith(response.config.url, window.env.REACT_APP_SINE_CORE_API_ENDPOINT)) {
    apiVersionService.setApiVersion('core', response.headers[SineHeader.X_SINE_VERSION] || 'Unknown');
    axios.interceptors.response.eject(coreApiVersionInterceptor);
  }
  return response;
});

const pluginsApiVersionInterceptor = axios.interceptors.response.use((response) => {
  if (startsWith(response.config.url, window.env.REACT_APP_SINE_PLUGINS_API_ENDPOINT)) {
    apiVersionService.setApiVersion('plugins', response.headers[SineHeader.X_SINE_VERSION] || 'Unknown');
    axios.interceptors.response.eject(pluginsApiVersionInterceptor);
  }
  return response;
});

const reportingApiVersionInterceptor = axios.interceptors.response.use((response) => {
  if (startsWith(response.config.url, window.env.REACT_APP_SINE_REPORTING_API_ENDPOINT)) {
    apiVersionService.setApiVersion('reporting', response.headers[SineHeader.X_SINE_VERSION] || 'Unknown');
    axios.interceptors.response.eject(reportingApiVersionInterceptor);
  }
  return response;
});
